


document.addEventListener("DOMContentLoaded", function () {
  const maxMenuTitleLength = 11; // ✅ Настроить длину для ссылок в меню 
  const maxCollectionTitleLength = 8; // ✅ Настроить длину для названий коллекций

  // Функция для обрезки текста
  function truncateText(selector, maxLength) {
    document.querySelectorAll(selector).forEach(element => {
      const originalText = element.textContent.trim();
      if (originalText.length > maxLength) {
        element.textContent = originalText.substring(0, maxLength) + "…";
        element.setAttribute("data-title", originalText); // Сохраняем полный текст
      }
    });
  }

  // Обрезаем ссылки в меню
  truncateText(".menu-link-mobile", maxMenuTitleLength);

  // Обрезаем названия коллекций при загрузке
  setTimeout(() => {
    truncateText(".collection-item-mobile span", maxCollectionTitleLength);
  }, 500); // Даем 0.5 секунды на загрузку коллекций (если они генерируются динамически)

  // Следим за изменениями в контейнере коллекций и повторно обрезаем текст
  const observer = new MutationObserver(() => {
    truncateText(".collection-item-mobile span", maxCollectionTitleLength);
  });

  const collectionsContainer = document.querySelector(".collections-grid-mobile");
  if (collectionsContainer) {
    observer.observe(collectionsContainer, { childList: true, subtree: true });
  }
});








